import { render, staticRenderFns } from "./NeedHelp.vue?vue&type=template&id=0bf56af4&scoped=true"
import script from "./NeedHelp.vue?vue&type=script&lang=js"
export * from "./NeedHelp.vue?vue&type=script&lang=js"
import style0 from "./NeedHelp.vue?vue&type=style&index=0&id=0bf56af4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf56af4",
  null
  
)

export default component.exports